<template>
    <div class="three-column-layout">
        <div
            id="above-three-column-layout"
            class="header-content">
        </div>
        <div
            v-if="$slots.banner"
            class="three-column-layout__banner"
            data-test="banner">
            <slot name="banner"></slot>
        </div>

        <div class="three-column-layout__header">
            <div
                v-if="$slots['header-main']"
                class="three-column-layout__header-main"
                data-test="header-main">
                <slot name="header-main"></slot>
            </div>
        </div>

        <div class="three-column-layout__content-wrapper">
            <div
                v-if="showLeft"
                ref="leftCol"
                class="three-column-layout__content-thin"
                data-test="three-column-layout__content-thin">
                <slot name="content-start"></slot>
            </div>
            <div
                :class="{ 'two-cols-wide': !hasThirdColumn }"
                class="three-column-layout__content-wide"
                data-test="three-column-content">
                <slot name="content-middle"></slot>
            </div>
            <div
                v-if="hasThirdColumn"
                ref="rightCol"
                data-test="three-column-content-right"
                :aria-label="
                    $formatMessage({
                        defaultMessage: 'Right (navigation) column',
                        id: 'layouts.rightColumn.ariaLabel',
                    })
                "
                class="three-column-layout__content-thin">
                <slot name="content-end"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import { stickyScroll } from "@eg_ui/src/mixins/globals/stickyScroll";

    export default {
        mixins: [stickyScroll],
        props: {
            showLeft: { type: Boolean, default: true },
        },
        computed: {
            hasThirdColumn() {
                return this.$slots && this.$slots["content-end"];
            },
        },
    };
</script>

<style lang="scss">
    @use "./ThreeColumnLayout.scss";
</style>
